import { Funnel } from '@phosphor-icons/react';
import { DatePicker } from 'rsuite';
import RadioBtn from '@Common/RadioBtn';
import { useEffect, useRef } from 'react';
import 'rsuite/DatePicker/styles/index.css'; // for datepicker styles

interface FilterPodsProps {
  showFilter: boolean;
  setShowFilter: (show: boolean) => void;
  selectedDateFilter: string;
  setSelectedDateFilter: (value: string) => void;
  filterStartDate: Date | null;
  setFilterStartDate: (date: Date | null) => void;
  filterEndDate: Date | null;
  setFilterEndDate: (date: Date | null) => void;
  disabled: boolean;
}

const FilterPods = ({
  showFilter,
  setShowFilter,
  selectedDateFilter,
  setSelectedDateFilter,
  filterStartDate,
  setFilterStartDate,
  filterEndDate,
  setFilterEndDate,
  disabled,
}: FilterPodsProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowFilter(false);
      }
    };

    if (showFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilter, setShowFilter]);

  return (
    <>
      <div>
        <Funnel
          onClick={() => {
            if (!disabled) {
              setShowFilter(!showFilter);
            }
          }}
          weight={showFilter ? 'fill' : 'regular'}
          size={28}
          className={`cursor-pointer text-primary-700 ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
        />
      </div>

      {showFilter && (
        <div
          ref={dropdownRef}
          className="absolute right-0 top-full z-50 mt-1 flex w-[90%] flex-col gap-2 rounded-md border bg-white p-4 text-primary-700 shadow-lg"
        >
          <div className="flex flex-col items-start gap-[0.4rem]">
            <RadioBtn
              label="Entire Pod"
              checked={selectedDateFilter === 'entire pod'}
              group="filterType"
              value="entire pod"
              setSelectedDateFilter={setSelectedDateFilter}
              disabled={disabled}
            />
            <RadioBtn
              label="Between"
              checked={selectedDateFilter === 'between'}
              group="filterType"
              value="between"
              setSelectedDateFilter={setSelectedDateFilter}
              disabled={disabled}
            />
            <RadioBtn
              label="Before"
              checked={selectedDateFilter === 'before'}
              group="filterType"
              value="before"
              setSelectedDateFilter={setSelectedDateFilter}
              disabled={disabled}
            />
            <RadioBtn
              label="After"
              checked={selectedDateFilter === 'after'}
              group="filterType"
              value="after"
              setSelectedDateFilter={setSelectedDateFilter}
              disabled={disabled}
            />
            {/* <RadioBtn
              label="Custom"
              checked={selectedDateFilter === 'custom'}
              group="filterType"
              value="custom"
              setSelectedDateFilter={setSelectedDateFilter}
              disabled={disabled}
            /> */}
          </div>

          <div className="mt-2 flex flex-col items-start gap-2">
            {selectedDateFilter === 'between' && (
              <div className="flex w-full items-center justify-start gap-2">
                <DatePicker
                  placeholder="Start date"
                  value={filterStartDate}
                  onChange={(date: Date | null) => setFilterStartDate(date)}
                  size="xs"
                  disabled={disabled}
                  container={dropdownRef.current || undefined}
                />
                <label className="font-semibold">-</label>
                <DatePicker
                  placeholder="End date"
                  value={filterEndDate}
                  onChange={(date: Date | null) => setFilterEndDate(date)}
                  size="xs"
                  disabled={disabled}
                  container={dropdownRef.current || undefined}
                />
              </div>
            )}
            {selectedDateFilter === 'before' && (
              <div className="flex w-full items-center justify-start gap-2">
                <DatePicker
                  placeholder="Select a date"
                  value={filterEndDate}
                  onChange={(date: Date | null) => setFilterEndDate(date)}
                  size="xs"
                  disabled={disabled}
                  container={dropdownRef.current || undefined}
                />
              </div>
            )}
            {selectedDateFilter === 'after' && (
              <div className="flex w-full items-center justify-start gap-2">
                <DatePicker
                  placeholder="Select a date"
                  value={filterStartDate}
                  onChange={(date: Date | null) => setFilterStartDate(date)}
                  size="xs"
                  disabled={disabled}
                  container={dropdownRef.current || undefined}
                />
              </div>
            )}
            {selectedDateFilter === 'custom' && (
              <div className="flex w-full items-center justify-start gap-2">
                <label className="text-[.70rem] font-semibold">More than</label>
                <input
                  type="number"
                  className="w-12 rounded-md border px-1 text-[0.75rem] outline-none"
                  placeholder="Days"
                  disabled={disabled}
                />
                <label className="text-[.70rem] font-semibold">days ago</label>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FilterPods;
